module.exports = __webpack_public_path__ + "img/R-7.5bb7460c.png";